<template lang="html">
  <div class="rating" v-if='comment >= 0'>
    <img v-for="i in parseInt(comment)" :key="i" :src="full">
    <img v-if="comment.toString().indexOf('.') > 0" :src="half">
    <img v-for="i in parseInt(5 - comment)" :key="i * 6" :src="empty">
  </div>
</template>

<script>
  export default {
    props: ["comment"],

    data() {
      return {
        full: require('../assets/image/icon/icon3.png'),
        empty: require('../assets/image/icon/icon4.png'),
        half: require('../assets/image/icon/icon5.png'),
      }
    },
  }
</script>

<style lang="css" scoped>
  .rating {
    display: flex;
    align-items: center;
  }
  
  .rating img {
    width: 1.2rem;
    height: 1.2rem;
    margin-left: .25rem;
  }
</style>
